function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { Children, cloneElement, useEffect, useRef, useState, useMemo } from "react";
var ColumnMarquee = function ColumnMarquee(_ref) {
  var _ref$autoplayInterval = _ref.autoplayInterval,
    autoplayInterval = _ref$autoplayInterval === void 0 ? 3000 : _ref$autoplayInterval,
    _ref$loop = _ref.loop,
    loop = _ref$loop === void 0 ? false : _ref$loop,
    children = _ref.children,
    wrapperStyles = _ref.wrapperStyles,
    scrollHeight = _ref.scrollHeight,
    uuid = _ref.uuid;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    flag = _useState2[0],
    setFlag = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    count = _useState4[0],
    setCount = _useState4[1];
  var containnerRef = useRef(null);
  var timeId = useRef(0);
  var _useState5 = useState(scrollHeight !== null && scrollHeight !== void 0 ? scrollHeight : 0),
    _useState6 = _slicedToArray(_useState5, 2),
    stepHeight = _useState6[0],
    setStepHeight = _useState6[1];
  var firstChildRef = useRef(null);
  var cloneMemo = useMemo(function () {
    if (!children || !Children.toArray(children).length) return [];
    var clone = Children.toArray(children).map(function (item) {
      return /*#__PURE__*/cloneElement(item, {
        key: uuid()
      });
    });
    return loop ? [].concat(_toConsumableArray(clone), [/*#__PURE__*/cloneElement(clone[clone.length - 1], {
      key: uuid()
    })]) : [];
  }, [loop]);
  useEffect(function () {
    var _a;
    if (scrollHeight || !firstChildRef.current) return;
    var firstChildHeight = (_a = firstChildRef.current.getBoundingClientRect().height) !== null && _a !== void 0 ? _a : 0;
    var styles = window.getComputedStyle(firstChildRef.current);
    var margin = parseFloat(styles["marginTop"]) + parseFloat(styles["marginBottom"]);
    setStepHeight(firstChildHeight + margin);
  }, [scrollHeight, firstChildRef, children]);
  useEffect(function () {
    timeId.current = window.setTimeout(function () {
      setFlag(true);
      setCount(function (prev) {
        return prev + 1;
      });
    }, autoplayInterval);
    var childLength = Children.toArray(children).length;
    var childrenLength = loop ? childLength * 2 - 1 : childLength;
    if (count >= childrenLength) {
      setTimeout(function () {
        setFlag(false);
        setCount(0);
      }, 1000);
    }
    return function () {
      return clearTimeout(timeId.current);
    };
  }, [count, loop]);
  // if (Children.toArray(children).length <= 1) {
  //   throw new Error('');
  // }
  if (!children) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: 'marquee-wrapper',
    style: wrapperStyles
  }, /*#__PURE__*/React.createElement("div", {
    className: "marquee-list ".concat(flag ? "animate" : ""),
    style: Object.assign(Object.assign({}, wrapperStyles), {
      transform: "translate3d(0, ".concat(count * -stepHeight, "px, 0)")
    }),
    ref: containnerRef
  }, [].concat(_toConsumableArray(Children.toArray(children)), _toConsumableArray(cloneMemo)).map(function (child, index) {
    if (index === 0) {
      return Object.assign(Object.assign({}, child), {
        ref: firstChildRef
      });
    }
    return child;
  })));
};
export default ColumnMarquee;